import * as React from 'react';
import TextField from '@mui/material/TextField';
//import { useForm } from './FormProvider';

//import { Controller } from "react-hook-form"

//import { useState } from "react";

import {useFormContext} from 'react-hook-form';

import { Typography } from '@mui/material';
import { Controller } from "react-hook-form"


const FormNumberTextField = React.forwardRef(({ name, label, required, rules = {}, min, max, refValue, shrinkLabel=undefined ,...props }, ref) => {
  const { control, formState, watch } = useFormContext();

  const errors = formState.errors;

  const requiredDefaultRule = required ? { required: { value: true, message: "This field is required" } } : {};
  rules = { ...requiredDefaultRule, ...rules };

  const minMaxRule = {
    validate: (value) => {
      const numeric = Number(value);
      if (isNaN(numeric)) return "Must be a number";
      if (min !== undefined && numeric < min) return `Must be larger or equal to ${min}`;
      if (max !== undefined && numeric > max) return `Must be smaller or equal to ${max}`;
      return true;
    },
  };


  rules = { ...requiredDefaultRule, ...minMaxRule, ...rules };

  if (refValue) {
    refValue.current = watch(name);
  }

  const [localVal, setLocalVal] = React.useState(0);

  return (
    <Controller
        render={({field: {onChange, value, onBlur}}) =>{

          const localOnChange = (event) => {
            const newvalue = event?.target?.value || '';
            const num = Number(newvalue);

            if (!isNaN(num)) {
              onChange(num);
              setLocalVal(num);
            } else {
              onChange(localVal);
            }
          }

          setLocalVal(value);

          return (
          <TextField
            label={label}
            value={value}
            onChange={localOnChange}
            onBlur={onBlur}
            variant="outlined"
            fullWidth
            required={required}
            error={!!errors[name]}
            helperText={errors[name] ? <Typography component="span">{errors[name]?.message?.toString()}</Typography> : null}
            InputLabelProps={{ shrink: shrinkLabel }}
            {...props}
          />)
        }}
        name={name}
        control={control}
        rules={rules}
    />
  );
});

export default FormNumberTextField;
